export default "__VITE_ASSET__B6r83hRL__"